import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { Actionbutton } from "src/app/shared/common/Actionbutton";
import { CreateTemplatePopupComponent } from "./create-template-popup/create-template-popup.component";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";
import { MatStepper } from "@angular/material/stepper";
import { constants } from "src/app/shared/common/contants";
import { JsonPipe } from "@angular/common";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { UploadWordTemplateComponent } from "./upload-word-template/upload-word-template.component";
import { GenerateButton } from "src/app/shared/common/generate-button.component";
import { GeneratedSplitReport } from "src/app/shared/common/generatedsplitreport";
import { FiledownloadComponent } from "src/app/shared/common/filedownload.component";
import { MatExpansionPanel } from "@angular/material/expansion";
import { ReviewActivityPopupConfigComponent } from "../../review-activity-config/review-activity-popup-config/review-activity-popup-config.component";

@Component({
    selector: "app-create-template",
    templateUrl: "./create-template.component.html",
    styleUrls: ["./create-template.component.scss"],
    standalone: false
})
export class CreateTemplateComponent implements OnInit {
  @ViewChild("stepper") stepper!: MatStepper;
  @ViewChild("chooserTpl", { static: true }) chooserTpl!: TemplateRef<any>;
  @Output() cancel = new EventEmitter<boolean>();
  @Input() cancelManually = false;
  activitySearchText: string;
  filteredActivities: { lookupvalue: string }[] = [];
  activityOptions: any;
  SignalSources: any;
  stepOneFormGroup: FormGroup;
  lookups = [
    { key: "activityOptions", assignTo: "activityOptions" },
    { key: "SignalSources", assignTo: "SignalSources" },
  ];
  backgroundColorScreen: string;
  backgroundColorButton: string;
  tableGrid = Array(8).fill(0); // 8x8 max
  tableCols = 0;
  tableRows = 0;
  selectedFileName: string | null = null;
  previewData: any[] = [];
  previewActivities: { activity: string }[] = [];
  // dialog state
  // default to 'new'
  mode: "";
  templates: any;
  selectedId?: number;
  // show form when ready
  showForm = false;
  gridAPI: any;
  gridColumnAPI: any;
  gridmgrnAPI: any;
  RunpageSize = 10;
  value: any;
  RuncurrentPage;
  RuntotalPages;
  RunlastPage;
  RunnextPage;
  RunnextPagePlusOne;
  defaultColDef = { sortable: true, resizable: true, filter: true,
    filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      }
   };
  columnDefs = [
    {
      headerName: "Action",
      filter: false,
      headerTooltip: "Action",
      cellRenderer: "jsignalButton",
      pinned: "left",
      lockPinned: true,
      cellRendererParams: {
        onPreview: this.previewFile.bind(this),
        edit: this.EditIcon.bind(this),
        delete: this.deleteIcon.bind(this),
      },
      width: 180,
    },

    {
      headerName: "Template Name",
      field: "templateName",
      
      filter: "agTextColumnFilter",
      headerTooltip: "Template Name",
      tooltipValueGetter: (params) => "Template Name : " + params.value,
      width: 220,
    },
    {
      headerName: "Upload Word Template",
      headerTooltip: "Upload Word Template",
      tooltipValueGetter: (params) => "Upload Word Template",
      filter: false,
      cellRenderer: "generateBttn",
      cellRendererParams: {
        generateReport: this.uploadWordTemplate.bind(this),
      },
      width: 120,
    },
    {
      headerName: "Download  Word Template",
      headerTooltip: "Download  Word Template",
      cellRenderer: FiledownloadComponent,
      cellRendererParams: {
        docdownload: this.downloadGeneratedWordTemplate.bind(this),
      },
      width: 200,
    },
    {
      headerName: "Created By",
      field: "createdBy",
     
      filter: "agNumberColumnFilter",
      headerTooltip: "Created By",
      tooltipValueGetter: (params) => "Created By : " + params.value,
      width: 200,
    },
    {
      headerName: "Created Date",
      field: "createdDate",
 
      filter: "agNumberColumnFilter",
      headerTooltip: "Created Date",
      tooltipValueGetter: (params) => "Created Date : " + params.value,
      width: 180,
    },
    {
      headerName: "Last Modified By ",
      field: "lastModifiedBy",
  
      filter: "agNumberColumnFilter",
      headerTooltip: "Last Modified By ",
      tooltipValueGetter: (params) => "Last Modified By : " + params.value,
      width: 120,
    },
    {
      headerName: "Last Modified Date ",
      field: "lastModifiedDate",
     
      filter: "agNumberColumnFilter",
      headerTooltip: "Last Modified Date",
      tooltipValueGetter: (params) => "Last Modified Date  : " + params.value,
      width: 120,
    },
    {
      headerName: "Status",
      headerTooltip: "Status",
      tooltipValueGetter: (params) => "Status : " + params.value,
      field: "status",
      filter: "agTextColumnFilter",
      width: 80,
    },
    {
      headerName: "Word Template Generation Status",
      headerTooltip: "Word Template Generation Status",
      tooltipValueGetter: (params) => "Word Template Generation Status : " + params.value,
      field: "wordtemplate_generation_status",
      filter: "agTextColumnFilter",
      width: 200,
    },
    
  ];
  // if the record has status==no , row color will change
  rowClassRules = {
    sick: function (params) {
      var numSickDays = params.node.data.status;
      return numSickDays === "No" || numSickDays === null;
    },
  };
  getRowStyle = (params: any) => {
    console.log(params);
    console.log(params.data.status);
    if (params.data.status === "No") {
      return { backgroundColor: "rgb(211, 211, 211)" }; // Inline style for deleted rows
    }
    // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
  };

  gridRowData = [];
  paginationPageSize: any;
  paginationNumberFormatter: any;
  components: any;

  copyTemplateName: any;
  selectedActivities: string[] = [];
  templateName: number;
  selectedTemplateId: any;
  templateId: any;
  editingTemplateId: any;
  DeleteStrategy: any;
  isEdit: boolean;
  previewMode = false;
  panelOpenState=true
  isSidenavOpen=false
  selectedProductDetails:any=null;
  constructor(
    private fb: FormBuilder,
    private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
    private jsignalsService: JsignalService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private dialog: MatDialog,
    private constants: constants
  ) {
   
  }

  ngOnInit(): void {
    this.loadActiveReviewActivities();
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    // Fetch all lookups (To add new lookup Mention In lookups[]  )
    this.lookups.forEach((lookup) => {
      this.commonService.getlookupVauleByLookUpType(lookup.key).subscribe({
        next: (result: any) => {
          console.log(`Lookup "${lookup.key}" (${lookup.assignTo}):`, result);
          // assign every lookup to its target property
          (this as any)[lookup.assignTo] = result;

          // only seed filteredActivities when activityOptions arrives
          // if (lookup.assignTo === "activityOptions") {
          //   if (Array.isArray(result)) {
          //     this.filteredActivities = result.map((r: any) => ({
          //       lookupvalue: r.lookupvalue,
          //     })); // result becomes Lookup[]
          //   } else {
          //     console.warn(
          //       `Expected activityOptions to be an array, got:`,
          //       result
          //     );
          //     this.filteredActivities = [];
          //   }
          // }
        },
        error: (err) => {
          console.error(`Error loading lookup "${lookup.key}":`, err);
        },
      });
    });
    this.loadGridData();
    this.components = {
      jsignalButton: JSIGNALBUTTON,
      generateBttn: GenerateButton,
      generatedSplitReport: GeneratedSplitReport,
      downloadbuttonRenderer: FiledownloadComponent,
    };
     this.stepOneFormGroup = this.fb.group({
      templateName: ["", Validators.required],
      activities: [],
      sections: this.fb.array([]),
    });
  }
togglePanel(event: MouseEvent, panel: MatExpansionPanel): void {
  event.stopPropagation(); // prevent header default toggle
  panel.toggle();
}
// All other header buttons: do action only, no toggle
onCreateTemplate(event: MouseEvent): void {
  event.stopPropagation();
  this.CreateTemplate();
}

onDownloadHistory(event: MouseEvent): void {
  event.stopPropagation();
  this.onDownloadhistory();
}

onRefresh(event: MouseEvent): void {
  event.stopPropagation();
  this.onrefresh();
}
  clearActivitySearch() {
    this.activitySearchText = "";
    this.filteredActivities = [...this.activityOptions];
  }
  filterActivities() {
    const search = this.activitySearchText?.toLowerCase() || "";
    this.filteredActivities = this.activityOptions.filter((a) =>
      a.activityName?.toLowerCase().includes(search)
    );
  }
  get stepOneSections(): FormArray {
    return this.stepOneFormGroup.get("sections") as FormArray;
  }
  onSectionReorder(e: CdkDragDrop<FormGroup[]>) {
    // re‐order the FormArray itself:
    const fa = this.stepOneSections;
    moveItemInArray(fa.controls, e.previousIndex, e.currentIndex);
    fa.updateValueAndValidity();
  }
  removeStepOneSection(index: number) {
    this.stepOneSections.removeAt(index);
  }
  addStepOneSection() {
    this.stepOneSections.push(
      this.fb.group({
        type: ["Text"],
        title: ["", Validators.required],
        description: [""],
      })
    );
  }
  onGridHover(rows: number, cols: number) {
    this.tableRows = rows;
    this.tableCols = cols;
  }
  // // 3) Push an “empty” table section into your FormArray
  addTableSection(rows: number, cols: number) {
    // build a FormArray of `cols` empty header controls:
    const colArray = this.fb.array(
      Array(cols)
        .fill(0)
        .map(() => this.fb.control(""))
    );
    // build a FormArray of `rows` FormArrays, each with `cols` empty cells:
    const rowArray = this.fb.array(
      Array(rows)
        .fill(0)
        .map(() =>
          this.fb.array(
            Array(cols)
              .fill(0)
              .map(() => this.fb.control(""))
          )
        )
    );

    this.stepOneSections.push(
      this.fb.group({
        type: ["Table"],
        title: ["", Validators.required],
        // keep the same JSON shape you had before:
        columns: colArray,
        rows: rowArray,
      })
    );

    // reset hover so it doesn’t show stale numbers if reopened:
    this.tableRows = this.tableCols = 0;
  }
  cancelWorkflow() {
    this.showForm = false;
    this.resetState();
  }
  // This is called when user clicks “Next”
  goToStepTwo(stepper: any) {
    if (this.stepOneFormGroup.invalid) {
      this.stepOneFormGroup.markAllAsTouched();
      return;
    }

    const templateName = this.stepOneFormGroup.get("templateName")!.value;

    // Only check uniqueness if we are in "create" mode
    if (!this.isEdit) {
      this.jsignalsService.getUniqueTemplateName(templateName).subscribe({
        next: (res) => {
          if (res?.error) {
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            return;
          }
          this.buildPreviewAndNext(stepper);
        },
        error: (err) => {
          this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
        },
      });
    } else {
      // In edit mode, skip name check
      this.buildPreviewAndNext(stepper);
    }
  }

  private buildPreviewAndNext(stepper: any) {
    const rawActivities: string[] =
      this.stepOneFormGroup.get("activities")!.value;
    this.previewActivities = rawActivities.map((a) => ({ activity: a }));
    // Build preview data from form array
    this.previewData = this.stepOneSections.controls.map((sec, idx) => {
      const type = sec.get("type")!.value;
      const base = {
        key: `section${idx + 1}`,
        type,
        title: sec.get("title")!.value,
      };

      if (type === "Text") {
        return {
          ...base,
          description: sec.get("description")!.value,
          // only show these if user filled them
          ...(sec.get("toolsMethods")?.value
            ? { toolsMethods: sec.get("toolsMethods")!.value }
            : {}),
          ...(sec.get("signalSources")?.value
            ? { signalSources: sec.get("signalSources")!.value }
            : {}),
        };
      }

      if (type === "Table") {
        return {
          ...base,
          columns: sec.get("columns")!.value,
          rows: sec.get("rows")!.value,
        };
      }

      return base;
    });

    stepper.next();
  }

  onCsvUpload(event: any): void {
    const input = event.target as HTMLInputElement;
    if (!input?.files?.length) {
      console.log("User canceled file dialog");
      input.value = ""; // 👈 important: reset so next click triggers again
      return;
    }

    const file = input.files[0];
    this.selectedFileName = file.name;
    this.spinner.start();
    const reader = new FileReader();
    reader.onload = () => {
      const text = String(reader.result || "")
        .replace(/\r\n/g, "\n")
        .trim();
      try {
        const rows = this.parseCsvToObjects(text);
        // Basic header validation:
        if (!rows.length) {
          this.snackBar.open("CSV is empty", "Close", { duration: 3000 });
          input.value = "";
          this.spinner.stop();
          return;
        }
        const hdrs = Object.keys(rows[0]);
        if (!hdrs.includes("type") || !hdrs.includes("title")) {
          this.snackBar.open(
            "CSV must have headers: 'type' and 'title' (case-sensitive)",
            "Close",
            { duration: 4000 }
          );
          input.value = "";
          this.spinner.stop();
          return;
        }

        // For each CSV row, add section immediately
        rows.forEach((r, i) => {
          const type = (r.type || "Text").trim();
          const title = r.title || `Section ${i + 1}`;

          if (type === "Table") {
            // infer columns & rows
            let columns: string[] = [];
            let tableRows: string[][] = [];

            if (r.columns && r.columns.trim())
              columns = r.columns
                .split("|")
                .map((s: string) => s.trim())
                .filter(Boolean);
            if (r.rows && r.rows.trim())
              tableRows = r.rows
                .split(";;")
                .map((rr: string) =>
                  rr.split("|").map((c: string) => c.trim())
                );

            // extra header columns (col1,col2,..)
            const baseKeys = [
              "type",
              "title",
              "description",
              "signalSources",
              "toolsMethods",
              "columns",
              "rows",
            ];
            const extraKeys = Object.keys(r).filter(
              (k) => !baseKeys.includes(k)
            );
            if (!columns.length && extraKeys.length) {
              columns = extraKeys;
              tableRows = [extraKeys.map((k) => r[k] ?? "")];
            }

            // fallback defaults
            if (!columns.length) columns = ["Column 1", "Column 2", "Column 3"];
            if (!tableRows.length) tableRows = [columns.map(() => "")];

            // normalize row lengths
            const colCount = columns.length;
            tableRows = tableRows.map((row) => {
              const c = row.slice(0, colCount);
              while (c.length < colCount) c.push("");
              return c;
            });

            // add UI section via existing helper
            this.addTableSection(tableRows.length, columns.length);

            // populate the newly added section (best-effort)
            try {
              const last = this.stepOneSections.length - 1;
              const sec = this.stepOneSections.at(last);
              sec.get("title")!.setValue(title);

              // set column headers (columns is FormArray of controls)
              const colsFA = sec.get("columns") as FormArray;
              columns.forEach((h, ci) => {
                if (colsFA.at(ci)) colsFA.at(ci).setValue(h);
              });

              // populate rows: your addTableSection creates rows as FormArray of FormArray
              const rowsFA = sec.get("rows") as FormArray;
              tableRows.forEach((rCells, ri) => {
                const rowFA = rowsFA.at(ri) as FormArray;
                if (!rowFA) return;
                rCells.forEach((cell, ci) => {
                  const ctrl = rowFA.at(ci) as any;
                  if (ctrl) ctrl.setValue(cell);
                });
              });
            } catch (err) {
              console.warn(
                "Populate table after addTableSection: best-effort failed",
                err
              );
            }
          } else {
            // Text section: use your addStepOneSection() then populate
            this.addStepOneSection();
            try {
              const last = this.stepOneSections.length - 1;
              const sec = this.stepOneSections.at(last);
              sec.get("title")!.setValue(title);
              if (sec.get("description"))
                sec.get("description")!.setValue(r.description || "");
              if (sec.get("signalSources")) {
                const ss = (r.signalSources || "")
                  .split("|")
                  .map((s: string) => s.trim())
                  .filter(Boolean);
                sec.get("signalSources")!.setValue(ss);
              }
              if (sec.get("toolsMethods"))
                sec.get("toolsMethods")!.setValue(r.toolsMethods || "");
            } catch (err) {
              console.warn("Populate text section: best-effort failed", err);
            }
          }
        });
        this.spinner.stop();
        this.snackBar.open("CSV imported into sections", "Close", {
          duration: 2000,
        });
      } catch (e) {
        console.error(e);
        this.spinner.stop();
        this.snackBar.open("Failed to parse CSV", "Close", { duration: 3000 });
      } finally {
        input.value = ""; // allow reselect same file
        this.spinner.stop();
      }
    };

    reader.onerror = (err) => {
      console.error(err);
      this.snackBar.open("File read error", "Close", { duration: 3000 });
      input.value = "";
    };
    reader.readAsText(file);
  }

  /* tiny CSV helpers (keeps things minimal but handles quoted fields) */
  private parseCsvToObjects(csvText: string): any[] {
    if (!csvText) return [];
    const lines = csvText.split("\n").filter((l) => l.trim() !== "");
    const headers = this.splitCsvLine(lines.shift()!);
    return lines.map((line) => {
      const vals = this.splitCsvLine(line);
      const obj: any = {};
      headers.forEach((h, i) => (obj[h.trim()] = (vals[i] ?? "").trim()));
      return obj;
    });
  }

  private splitCsvLine(line: string): string[] {
  const out: string[] = [];
  let cur = '';
  let inQ = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') { if (inQ && line[i+1] === '"') { cur += '"'; i++; } else inQ = !inQ; continue; }
    if (ch === ',' && !inQ) { out.push(cur); cur = ''; continue; }
    cur += ch;
  }
  out.push(cur);
  return out;
}

OnSubmit(): void {
  const templateName = this.stepOneFormGroup.get('templateName')!.value;
  const DnsName = this.localStorage.getSettings("dnsName");
  const Workspaceid = this.localStorage.getSettings("WorkspaceId");
  const defaultSections = [
  {
    "Section Title": "Document Control",
            "Section Type": "key-value",
            "DocControl": [
             {
              Column1: "",
              Column2: ""
            }
            ]   
  },
  {
    "Section Title": "Product Overview",
            "Section Type": "key-value",
            "productOV": [  
              { 
              Column1: "",
              Column2: ""
            }]   
  }
];

 let sectionCounter = 1;  // Initialize counter for sections

  // Transform previewData (Text + Table) into required structure
  const sections = this.previewData.map(sec => {
    const key = `section${sectionCounter++}`; // Increment per section

    if (sec.type.toLowerCase() === 'text') {
      return {
        "Section Title": sec.title,
        "Section Type": "text",
        [key]: (sec.description || '').split('\n').map(l => l.trim()).filter(Boolean)
      };
    }
    if (sec.type.toLowerCase() === 'table') {
      const rows = sec.rows.map(row => {
        const obj: any = {};
        sec.columns.forEach((col, idx) => {
          obj[col] = row[idx];  
        });
        return obj;
      });
      return {
        "Section Title": sec.title,
        "Section Type": "table",
        [key]: rows
      };
    }
    return null;
  }).filter(Boolean);

  // Transform previewActivities into activity table sections
const activitySection = {
  "Section Title": "Activity Details",
  "Section Type": "table",
  "activity": this.previewActivities.map(act => ({
    activity: act.activity,
    level: "",
    reviewPeriod: "",
    dueDays: "",
    durationHours: "",
    evidenceRequired: "",
    uploadInstructions: "",
    // rolesAllowed: "",
    startDate: "",
    activitydescripition:"",
  }))
};

  // Final JSON structure
  const templateContent = {
    "language": "en",
    "Product Name": "",
    "sections": [
       ...defaultSections,
       activitySection,
      ...sections
      
    ]
  };

  // Common payload
  const payload = {
    templateName,
    templateContent,
    dnsId: DnsName,
    workspaceId: Workspaceid,
    generateWordTemplate:true
  };
   console.log(' payloads:', JSON.stringify(payload, null, 2));
   this.spinner.start();

  if (this.editingTemplateId) {
    // UPDATE mode
    console.log("Inside Update Function",this.editingTemplateId);
    this.jsignalsService.updateProductStrategyTemplate(this.editingTemplateId, payload).subscribe({
       next: (res:any) => {
       this.snackBar.open(res.statusMessage, 'Ok', { duration: 3000 });
        this.spinner.stop();
        this.cancelWorkflow();
        this.loadGridData();
      },
       error: (err) => {
        this.spinner.stop();
        this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
      }
    });
  } else {
    // CREATE mode

    this.jsignalsService.createProductStrategyTemplate(payload).subscribe({
      next: (res:any) => {
        this.spinner.stop()
       this.snackBar.open(res.statusMessage, 'Ok', { duration: 3000 });
        this.cancelWorkflow();
        this.loadGridData();
      },
      error: (err) => {
                this.spinner.stop()

        this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
      }
    });
  }
}

  CreateTemplate() {
    this.dialog
      .open(CreateTemplatePopupComponent, {
        maxWidth: "100vw",
        height: "55%",
        width: "45%",
        disableClose: true,
        autoFocus: false,
      })
      .afterClosed()
      .subscribe((result) => {
        if (!result) return; // cancelled
        this.showForm = true;
        this.isEdit = false;
        this.previewMode = false;
        if (result.mode === "copy") {
          this.copyTemplateName = result.templateId!;
          this.loadAndPatch(this.copyTemplateName);
        } else {
          this.initBlankForm();
        }
      });
  }

  initBlankForm() {
    // reset your FormGroups/FormArrays here
    this.stepOneFormGroup.reset({ templateName: "" });
    this.stepOneSections.clear();
    this.stepOneFormGroup.get("activities")!.setValue([]);
  }

  loadAndPatch(templateName: any) {
    console.log("Template selected:", templateName);

    this.jsignalsService.getTemplateByName(templateName).subscribe({
      next: (res) => {
        try {
          // Parse the JSON string if needed
          const parsedJson =
            typeof res.templateContent === "string"
              ? JSON.parse(res.templateContent)
              : res.templateContent;

          // Pass parsed JSON directly
          this.loadFromDefault(parsedJson);

          // Store template id for later use
          this.selectedTemplateId = res.templateId;
        } catch (err) {
          console.error("Error parsing templateContent:", err);
        }
      },
      error: (err) => {
        console.error("Error loading template JSON:", err);
      },
    });
  }

  /* your existing stepper handlers go here… */

  onDownloadhistory() {
    this.spinner.start();

    setTimeout(() => {
      this.gridmgrnAPI.exportDataAsCsv({
        fileName: "SafetyStrategyTemplates.csv",
      });

      this.spinner.stop();
    }, 500);
  }
  onrefresh() {
    this.loadGridData();
  }
  onRunSearchChange(searchValue: number) {
    this.gridmgrnAPI.paginationGoToPage(searchValue - 1);
  }
  onRunPageSizeChanged(newPageSize) {
    console.log(this.RunpageSize);
    var value = this.RunpageSize;
    this.gridmgrnAPI.setGridOption('paginationPageSize', Number(value));
  }
  onRunBtFirst() {
    this.gridmgrnAPI.paginationGoToFirstPage();
  }
  onRunBtPrevious() {
    console.log("previous");
    this.gridmgrnAPI.paginationGoToPreviousPage();
  }
  onRunBtNext() {
    console.log("next");
    this.gridmgrnAPI.paginationGoToNextPage();
  }
  onRunBtLast() {
    this.gridmgrnAPI.paginationGoToLastPage();
  }

  EditIcon({ event, rowData }: any): void {
    if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }
    this.isEdit = true;
    this.previewMode = false;
    this.editingTemplateId = rowData.templateId;

    // Step 1: show form first
    this.showForm = true;

    // Step 2: patch name next
    this.stepOneFormGroup.patchValue({
      templateName: rowData.templateName,
    });

    // (optional) verify
    console.log(
      "Template name after patch:",
      this.stepOneFormGroup.get("templateName")?.value
    );

    // Step 3: parse and load JSON content
    const parsedJson = JSON.parse(rowData.templateContent);
    this.loadFromDefault(parsedJson);
  }

  deleteIcon({ event, rowData }: any): void {

    if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to Delete the selected Record ?"
    );
    if (!confirmed) {
      return;
    }
    this.spinner.start();
    console.log(rowData.templateId);
    this.DeleteStrategy = rowData.templateId;
    this.jsignalsService
      .deleteProductStrategyTemplate(this.DeleteStrategy)
      .subscribe({
        next: (res: any) => {
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.spinner.stop();
          this.loadGridData();
        },
        error: (err) => {
          console.error(" Delete error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
          this.spinner.stop();
          this.loadGridData();
        },
      });
  }

  onPaginationChanged() {
    if (this.gridmgrnAPI && !this.gridmgrnAPI.destroyed) {
      this.RunlastPage = this.gridmgrnAPI.paginationIsLastPageFound();
      this.RuncurrentPage = this.gridmgrnAPI.paginationGetCurrentPage() + 1;
      this.RunnextPage = this.gridmgrnAPI.paginationGetCurrentPage() + 1 + 1;
      this.RunnextPagePlusOne =
        this.gridmgrnAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.RuntotalPages = this.gridmgrnAPI.paginationGetTotalPages();
    }
  }

  onGridReady(params: any) {
    this.gridAPI = params.api;
    this.gridmgrnAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    this.gridmgrnAPI.setGridOption('paginationPageSize', Number(this.RunpageSize));
  }

  loadGridData() {
    this.spinner.start();
    this.jsignalsService.getAllTemplatesNonDefault().subscribe({
      next: (res: any) => {
        console.log("Templates loaded:", res);
        // this.snackBar.open(res.statusMessage, 'Ok', { duration: 3000 });
        this.gridRowData = res; // <-- This is critical!
        this.spinner.stop();
      },
      error: (err) => {
        console.error("Error loading templates:", err);
        this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
        this.gridRowData = [];
        this.spinner.stop();
      },
    });
  }

  loadFromDefault(json: any) {
    const sectionsFA = this.stepOneFormGroup.get("sections") as FormArray;
    sectionsFA.clear();

    // Helper to get the main payload of a section
    function getEachSectionKey(section: any): any {
      if (!section || typeof section !== "object") return null;
      const key = Object.keys(section).find(
        (k) => k !== "Section Title" && k !== "Section Type"
      );
      return key ? section[key] : null;
    }

    // STEP 1: Patch template name (from doc section if present)
    const docSection = json.sections.find((s: any) => "DocControl" in s);
    if (docSection) {
      const docData =
        (getEachSectionKey(docSection) as Array<{
          Column1: string;
          Column2: any;
        }>) || [];
      // const titleFromDoc = docData.find(
      //   (d) => d.Column1 === "Document Title"
      // )?.Column2;
      // this.stepOneFormGroup.patchValue({
      //   templateName: titleFromDoc || "",
      // });
    }

    // STEP 2: Extract and patch activities (if present)
    const activitySection = json.sections.find((s: any) =>
      Array.isArray(s.activity)
    );
    const activities = activitySection?.activity?.map((a) => a.activity) || [];
    this.stepOneFormGroup.patchValue({ activities });
    this.selectedActivities = activities;
    console.log(this.selectedActivities);

    // STEP 3: Build sections array (skip doc + activity)
    for (const sec of json.sections) {
      if (
        "DocControl" in sec ||
        "activity" in sec ||
        "productOV" in sec ||
        "history" in sec
      )
        continue;

      const title = sec["Section Title"];
      const type = sec["Section Type"];
      const payload = getEachSectionKey(sec);

      if (type === "table" && Array.isArray(payload)) {
        const colsSet = new Set<string>();
        payload.forEach((row) =>
          Object.keys(row).forEach((k) => colsSet.add(k))
        );
        const cols = Array.from(colsSet);
        const rows = payload.map((r) =>
          this.fb.array(cols.map((c) => r[c] ?? ""))
        );
        sectionsFA.push(
          this.fb.group({
            key: title,
            type: "Table",
            title,
            columns: this.fb.array(cols),
            rows: this.fb.array(rows),
          })
        );
      } else {
        const lines = Array.isArray(payload) ? payload : [];
        sectionsFA.push(
          this.fb.group({
            key: title,
            type: "Text",
            title,
            description: lines.join("\n"),
          })
        );
      }
    }
  }

  previewFile({ event, rowData }: any): void {
    if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }
    this.previewMode = true;
    this.isEdit = false;
    this.editingTemplateId = null;

    this.stepOneFormGroup.patchValue({
      templateName: rowData.templateName || "",
    });

    const parsedJson = JSON.parse(rowData.templateContent);
    this.loadFromDefault(parsedJson);

    this.showForm = true;
    this.spinner.start();

    // let Angular create the form arrays, then jump to preview step
    setTimeout(() => {
      if (this.stepper) {
        const wasLinear = this.stepper.linear;
        this.stepper.linear = false;
        this.buildPreviewAndNext(this.stepper); // builds previewData & calls stepper.next()
        this.stepper.linear = wasLinear;
        this.spinner.stop();
      }
    }, 50);
  }
  //added by kameshwar.d @date 09-09-2025

  uploadWordTemplate(e: any) {
    if (e.rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }

    const dialogRef = this.dialog.open(UploadWordTemplateComponent, {
      maxWidth: "100vw",
      height: "55%",
      width: "45%",
      data: { data: e.rowData },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => console.log(result));
  }

  //added by kameshwar.d @date 09-09-2025

  downloadGeneratedWordTemplate(e: any) {
    if (e.rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }
    const templateId = e.rowData.templateId;
    this.spinner.start();
    this.snackBar.open(
      "Download is underway. Please do not click again the download until it completes the download.",
      "OK",
      { duration: 10000 }
    );
    this.spinner.stop();

    this.jsignalsService.download_zip(templateId).subscribe({
      next: (blob: Blob) => {
        const zipBlob = new Blob([blob], { type: "application/zip" });

        // IE / Edge support
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveOrOpenBlob(
            zipBlob,
            `Template_${templateId}.zip`
          );
          return;
        }

        // Modern browsers
        const url = window.URL.createObjectURL(zipBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Template_${templateId}.zip`;

        document.body.appendChild(link);
        link.click();
        link.remove();

        // Release the object URL after download
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
      },
      error: (err) => {
        this.snackBar.open("Download failed", "OK", { duration: 10000 });
        console.error("Download failed", err);
      },
    });
  }
  resetState(){
    this.editingTemplateId = null ;
     this.stepOneFormGroup.reset();
  }

  onCreateActivityClick(){
   this.dialog.open(ReviewActivityPopupConfigComponent, {
             maxWidth: "100vw",
             height: "40%",
             width: "60%",
             disableClose: true,
           })
         .afterClosed()
         .subscribe((result) => {
            console.log(result);
            this.stepOneFormGroup.get("activities")!.setValue([]);
           if (result) {
            this.loadActiveReviewActivities(); // Refresh activities after adding new one
           
           }
         });

    
  }

  loadActiveReviewActivities(){
    this.jsignalsService
      .getAllActiveReviewActivityConfigs()
      .subscribe({
        next: (res: any) => {
          // this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.activityOptions = res;
          this.filteredActivities = [...res]; // make a copy for filtering
          console.log("Active Review Activities loaded:", res);
          this.spinner.stop();
     
        },
        error: (err) => {
          console.error(" error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
          this.activityOptions = [];
          this.filteredActivities = [];
          this.spinner.stop();
        },
      });
  }
}
